import {action, computed, observable} from 'mobx';
import {useLocalObservable} from 'mobx-react';
import {useEffect} from 'react';

export function useMobxComputed<T, D extends readonly [any] | any[]>(computeFn: (deps: D) => T, dependencies: D): T {
  const store = useLocalObservable(() => ({
    dependencies,

    setDependencies(newDependencies: D) {
      this.dependencies = newDependencies;
    },

    get value() {
      return computeFn(this.dependencies);
    },
  }), {value: computed, dependencies: observable.shallow, setDependencies: action});

  useEffect(() => {
    store.setDependencies(dependencies);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store, ...dependencies]);

  return store.value;
}
